import { createRouter, createWebHistory } from "vue-router";
import Dashboard from "./pages/Dashboard.vue";
import CreatePlayground from "./pages/CreatePlayground.vue";
import PlaygroundDetail from "./pages/PlaygroundDetail.vue";
import SignIn from "./pages/SignIn.vue";
import Unauthorized from "./pages/Unauthorized.vue";
import { authStore } from "./auth/authStore";
import { getAccount } from "./auth/msal";

export const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: "/", name: "dashboard", component: Dashboard, meta: { requiresAuth: true } },
    { path: "/playgrounds/new", name: "new-playground", component: CreatePlayground, meta: { requiresAuth: true } },
    { path: "/playgrounds/:slug", name: "playground-detail", component: PlaygroundDetail, meta: { requiresAuth: true } },
    { path: "/signin", name: "signin", component: SignIn },
    { path: "/auth/callback", redirect: "/" },
    { path: "/unauthorized", name: "unauthorized", component: Unauthorized, meta: { requiresAuth: true } },
    { path: "/:pathMatch(.*)*", redirect: "/" },
  ],
});

router.beforeEach((to) => {
  if (!to.meta.requiresAuth) return true;
  if (!getAccount()) return { name: "signin", query: { next: to.fullPath } };
  // Redirect to /unauthorized if /me returned no roles (load happens in main.ts).
  if (
    to.name !== "unauthorized" &&
    authStore.state.me &&
    !authStore.isAuthorized.value
  ) {
    return { name: "unauthorized" };
  }
  return true;
});
